import axios from "../util/axios";

const getProjects = (userId) => {
  return axios.get("/project/?user_id=" + userId);
}; //  **********************

const getProjectsDashboard = (userId) => {
  return axios.get("/project/dashboard/?user_id=" + userId);
};

const convertProjectIntoTasks = (data) => {
  return axios.post("/convert", data);
};

const getProjectTasks = (projectId) => {
  return axios.get(`/tasks/?project_id=${projectId}`);
};

const addTasksSubtasks = (task, subtask) => {
  return axios.post(`/subtask/multiple-create/`, { task, subtask });
};
const getUsersTasks = (userId) => {
  return axios.get(`/tasks/?user_id=${userId}`);
};

const getUserTeam = (userId) => {
  return axios.get(`/teams/?user_id=${userId}`);
};

const updateTaskStatus = (data, id) => {
  return axios.patch(`/tasks/${id}/`, data);
};

const generateSubTasks = (data) => {
  return axios.post("/subtaskgenerator", data);
};

const getSubTasks = (taskid) => {
  return axios.get(`/subtask/?task_id=${taskid}`);
};

const updateProjectStatus = (data, id) => {
  return axios.patch(`/project/${id}/`, data);
};

const getProjectsCount = (id) => {
  return axios.get(`/project/count/?user_id=${id}`);
};

const getProjectsByDivision = (userId, division) => {
  return axios.get(`/project/?division=${division}&user_id=${userId}`);
};

const getProjectsByTheme = (userId, theme) => {
  const encodedTheme = encodeURIComponent(theme);
  return axios.get(
    `/project/?strategicTheme=${encodedTheme}&user_id=${userId}`,
  );
};

const getPriorityProjectsByTheme = (userId) => {
  return axios.get(`/project/byStrategicTheme/?user_id=${userId}`);
};

const getProjectDetails = (id) => {
  return axios.get(`/project/${id}/`);
};

const getMilestones = (id) => {
  return axios.get(`/milestone/?project_id=${id}`);
};

const addNewTask = (data) => {
  return axios.post(`/tasks/`, data);
};

const updateSubTaskStatus = (data, id) => {
  return axios.patch(`/subtask/${id}/`, data);
};

const toggleVote = (userid, projectId) => {
  return axios.post(`/project/${projectId}/vote/`, { user_id: userid });
};

const hasVoted = (projectId, userId) => {
  return axios.get(`/project/${projectId}/check-vote/?user_id=${userId}`);
};

const addComment = (data) => {
  return axios.post(`/comment/`, data);
};

const getProjectComments = (projectId) => {
  return axios.get(`/comment/?project_id=${projectId}`);
};

const getDepartments = () => {
  return axios.get(`/departments/`);
};

const getDivisions = () => {
  return axios.get(`/divisions/`);
};

// Organisation usage (accurate monthly usage snapshot)
const getOrganisationUsage = (orgId) => {
  if (orgId) {
    return axios.get(`/organisation-usage/?org_id=${orgId}`);
  }
  return axios.get(`/organisation-usage/`);
};

const getUserDepartments = () => {
  return axios.get(`/departments/`);
};

const getUserDivisions = () => {
  return axios.get(`/divisions/`);
};
const getUserTeams = () => {
  return axios.get(`/teams/`);
};

const getStrategicThemes = () => {
  return axios.get(`/strategic-themes/`);
};

const getStrategicThemesClearPlan = () => {
  return axios.get(`/strategic-themes/clear-plan-strategic-themes/`);
};

const createNotification = (data) => {
  return axios.post(`/notification/`, data);
};

/**
 * Get paginated notifications with optional filters
 * @param {Object} params - Query parameters
 * @param {string} params.userId - User ID to filter by
 * @param {string} params.category - Category filter (decision, task, assurance, info, celebration)
 * @param {string} params.isRead - Read status filter ('true' or 'false')
 * @param {number} params.pageSize - Items per page (default 20, max 100)
 * @param {number} params.cursor - ID of last item for pagination
 */
const getNotifications = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.userId) queryParams.append("user_id", params.userId);
  if (params.category) queryParams.append("category", params.category);
  if (params.isRead !== undefined) queryParams.append("is_read", params.isRead);
  if (params.pageSize) queryParams.append("page_size", params.pageSize);
  if (params.cursor) queryParams.append("cursor", params.cursor);

  return axios.get(`/notification/?${queryParams.toString()}`);
};

// Legacy function - now calls paginated endpoint without pagination params
const getUsersNotification = (userId) => {
  return axios.get(`/notification/?user_id=${userId}`);
};

// Lightweight unread preview (navbar) - returns { unread: [...], unread_count }
const getUnreadNotificationPreview = (limit = 3) => {
  return axios.get(`/notification/unread-preview/?limit=${limit}`);
};

// Mark single notification as read (idempotent) - returns updated unread_count
const markNotificationRead = (id) => {
  return axios.post(`/notification/${id}/read/`, {});
};

const updateNotification = (data, id) => {
  return axios.patch(`/notification/${id}/`, data);
};

const readAllNotification = (data) => {
  return axios.post(`/notification/mark-all-read/`, data);
};

const deleteAllNotification = (data) => {
  return axios.post(`/notification/delete-unread/`, data);
};

// ============= STRATEGIC NOTIFICATION CENTER ACTIONS =============

const approveNotification = (id, data) => {
  return axios.post(`/notification/${id}/approve/`, data);
};

const rejectNotification = (id, data) => {
  return axios.post(`/notification/${id}/reject/`, data);
};

const delegateNotification = (id, data) => {
  return axios.post(`/notification/${id}/delegate/`, data);
};

const escalateNotification = (id, data) => {
  return axios.post(`/notification/${id}/escalate/`, data);
};

const getAssuranceScorecard = (id) => {
  return axios.get(`/notification/${id}/assurance-scorecard/`);
};

const getSuggestedEscalationTarget = (id) => {
  return axios.get(`/notification/${id}/suggested-escalation-target/`);
};

const flagNotificationForSupport = (id, data) => {
  return axios.post(`/notification/${id}/flag-for-support/`, data);
};

const updateNotificationChecklist = (id, data) => {
  return axios.patch(`/notification/${id}/update-checklist/`, data);
};

const updateNotificationEffort = (id, data) => {
  return axios.patch(`/notification/${id}/update-effort/`, data);
};

// =================================================================

const getAdminAnalytics = () => {
  return axios.get(`/details/`);
};

const createMilestone = (data) => {
  return axios.post(`/milestone/`, data);
};

const deleteMilestone = (id) => {
  return axios.delete(`/milestone/${id}/`);
};

const addNote = (data) => {
  return axios.post(`/note/`, data);
};

// Billing & Plans
const getPlanMetadata = () => {
  return axios.get(`/plan-metadata/`);
};

const createCheckoutSession = ({ plan_slug, billing_cycle, seat_count }) => {
  return axios.post(`/checkout-session/`, {
    plan_slug,
    billing_cycle,
    seat_count,
  });
};

// Billing: estimate proration for mid-cycle seat changes
const estimateProration = ({ plan_slug, billing_cycle, seat_count }) => {
  return axios.post(`/billing/estimate/`, {
    plan_slug,
    billing_cycle,
    seat_count,
  });
};

// Billing: apply seat updates with proration
const updateSeats = ({ plan_slug, billing_cycle, seat_count }) => {
  return axios.post(`/billing/update-seats/`, {
    plan_slug,
    billing_cycle,
    seat_count,
  });
};

const deleteNote = (id) => {
  return axios.delete(`/note/${id}/`);
};

const updateNote = (data, id) => {
  return axios.patch(`/note/${id}/`, data);
};

const getProjectNotes = (id, userId) => {
  return axios.get(`/note/?project_id=${id}&?user_id=${userId}`);
};

const updateMilestone = (data, id) => {
  return axios.patch(`/milestone/${id}/`, data);
};

// Meeting Notes (AI project update workflow)
const uploadMeetingNotes = (projectId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`/project/${projectId}/meeting-notes/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const proposeMeetingNotes = (projectId, jobId) => {
  return axios.post(
    `/project/${projectId}/meeting-notes/${jobId}/propose/`,
    {},
  );
};

const getMeetingNotesJob = (projectId, jobId) => {
  return axios.get(`/project/${projectId}/meeting-notes/${jobId}/`);
};

const applyMeetingNotes = (projectId, jobId, accepted_op_ids) => {
  return axios.post(`/project/${projectId}/meeting-notes/${jobId}/apply/`, {
    accepted_op_ids,
  });
};

// Convenience function: upload file + generate proposal in one call
const generateMeetingNotesProposal = async (formData) => {
  const projectId = formData.get("project_id");
  const file = formData.get("file");

  // Step 1: Upload the file
  const uploadRes = await uploadMeetingNotes(projectId, file);
  const jobId = uploadRes?.data?.id;

  if (!jobId) {
    throw new Error("Failed to upload meeting notes");
  }

  // Step 2: Generate proposal
  await proposeMeetingNotes(projectId, jobId);

  // Step 3: Get the job with proposed changeset
  const jobRes = await getMeetingNotesJob(projectId, jobId);
  return jobRes;
};

// Apply selected meeting notes changes
const applyMeetingNotesChanges = async ({
  job_id,
  selected_ops,
  project_id,
}) => {
  return applyMeetingNotes(project_id, job_id, selected_ops);
};

// ==================== Benefit Realization Tracking ====================

/**
 * Classify benefits for a session to determine tracking types
 * @param {string} sessionId - The session UUID
 */
const classifyBenefits = (sessionId) => {
  return axios.post(`/session/${sessionId}/classify-benefits/`);
};

/**
 * Get milestone benefit links for a project
 * @param {number} projectId - The project ID
 */
const getMilestoneBenefitLinks = (projectId) => {
  return axios.get(`/project/${projectId}/milestone-benefit-links/`);
};

/**
 * Create a milestone benefit link
 * @param {number} projectId - The project ID
 * @param {object} data - { milestone_id, cost_benefit_id, expected_percent }
 */
const createMilestoneBenefitLink = (projectId, data) => {
  return axios.post(`/project/${projectId}/milestone-benefit-links/`, data);
};

/**
 * Bulk create milestone benefit links (used during project conversion)
 * @param {number} projectId - The project ID
 * @param {array} links - Array of { milestone_id, cost_benefit_id, expected_percent }
 */
const bulkCreateMilestoneBenefitLinks = (projectId, links) => {
  return axios.post(
    `/project/${projectId}/milestone-benefit-links/bulk-create/`,
    {
      links,
    },
  );
};

/**
 * Update a milestone benefit link
 * @param {number} linkId - The link ID
 * @param {object} data - Fields to update
 */
const updateMilestoneBenefitLink = (linkId, data) => {
  return axios.patch(`/milestone-benefit-link/${linkId}/`, data);
};

/**
 * Delete a milestone benefit link
 * @param {number} linkId - The link ID
 */
const deleteMilestoneBenefitLink = (linkId) => {
  return axios.delete(`/milestone-benefit-link/${linkId}/`);
};

/**
 * Confirm benefits when a milestone is completed
 * @param {number} milestoneId - The milestone ID
 * @param {array} confirmations - Array of { benefit_link_id, action, realized_amount, notes }
 */
const confirmMilestoneBenefits = (milestoneId, confirmations) => {
  return axios.post(`/milestone/${milestoneId}/confirm-benefits/`, {
    confirmations,
  });
};

/**
 * Get pending benefit confirmations for a project
 * @param {number} projectId - The project ID
 */
const getPendingBenefitConfirmations = (projectId) => {
  return axios.get(`/project/${projectId}/pending-benefit-confirmations/`);
};

/**
 * Get benefit realization summary for a project
 * @param {number} projectId - The project ID
 */
const getBenefitRealizationSummary = (projectId) => {
  return axios.get(`/project/${projectId}/benefit-realization-summary/`);
};

/**
 * Get recurring benefit reminders for the current organisation
 */
const getRecurringBenefitReminders = () => {
  return axios.get(`/recurring-benefit-reminders/`);
};

/**
 * Confirm a recurring benefit for a period
 * @param {number} costBenefitId - The cost benefit ID
 * @param {object} data - { actual_amount, notes, period_date }
 */
const confirmRecurringBenefit = (costBenefitId, data) => {
  return axios.post(`/cost-benefit/${costBenefitId}/confirm-recurring/`, data);
};

/**
 * Generate AI-powered benefit-milestone links for an existing project
 * @param {number} projectId - The project ID
 * @param {boolean} force - If true, regenerates links even if some exist
 */
const generateBenefitLinks = (projectId, force = false) => {
  const url = force
    ? `/project/${projectId}/generate-benefit-links/?force=true`
    : `/project/${projectId}/generate-benefit-links/`;
  return axios.post(url, {});
};

// ==================================================================

const getMilestoneTasks = (milestoneId) => {
  return axios.get(`/tasks/?milestone_id=${milestoneId}`);
};

const addEscalation = (data) => {
  return axios.post(`/escalation/`, data);
};

const getProjectEscalations = (id) => {
  return axios.get(`/escalation/?project_id=${id}`);
};

const updateEscalation = (id, data) => {
  return axios.patch(`/escalation/${id}/`, data);
};

const getEscalationComment = (id) => {
  return axios.get(`/comment/?escalation_id=${id}`);
};

// Create a comment on an escalation
const createEscalationComment = (data) => {
  return axios.post(`/comment/`, data);
};

// Get notification's associated escalation comments (if notification has escalation)
const getNotificationComments = (escalationId) => {
  return axios.get(`/comment/?escalation_id=${escalationId}`);
};

const deleteEscalation = (id) => {
  return axios.delete(`/escalation/${id}/`);
};

const searchUser = (email) => {
  return axios.get(`/users/?search=${email}`);
};

const createTeam = (data) => {
  return axios.post(`/teams/`, data);
};

const updateTeam = (id, data) => {
  return axios.patch(`/teams/${id}/`, data);
};

const deleteTeam = (id) => {
  return axios.delete(`/teams/${id}/`);
};

const addTemplate = (data) => {
  return axios.post(`/whiteboard/`, data);
};

const getTemplates = () => {
  return axios.get(`/whiteboard/?is_template=true`);
};

const getTemplateById = (id) => {
  return axios.get(`/whiteboard/${id}/`);
};

const getUserDrawings = (id) => {
  return axios.get(`/whiteboard/?is_template=false&user_id=` + id);
};

const deleteNotification = (id) => {
  return axios.delete(`/notification/${id}/`);
};

const getProjectDrawings = (id) => {
  return axios.get(`/whiteboard/?is_template=false&project_id=` + id);
};

const delegateToSeniors = (data, id) => {
  return axios.post(`/project/${id}/delegate/`, data);
};

const getAllProjects = (userId) => {
  // return axios.get(`/project/`,{headers:AuthHeader()});
  return axios.get(`/project/?user_id=${userId}`);
};

const getApprovalProjects = (userId) => {
  return axios.get(`/approval/?user_id=${userId}`);
};

const updateProfile = (data, userId) => {
  return axios.patch(`/users/${userId}/`, data);
};

const createChatRequest = (userId) => {
  return axios.post(`/chat-requests/`, { to_user_id: userId });
};

const getConversations = () => {
  return axios.get(`/my-rooms/`);
};

const getCurrentMessages = (roomId) => {
  return axios.get(`/messages/?room_id=${roomId}`);
};

const updateChatRequest = (id, data) => {
  return axios.patch(`/chat-requests/${id}/`, data);
};

const deleteDrawing = (id) => {
  return axios.delete(`/whiteboard/${id}/`);
};

const getAllUsers = () => {
  return axios.get(`/users/admin/`);
};

const updateUser = (data, id) => {
  return axios.patch(`/users/${id}/update-details/`, data);
};

const deleteUser = (id) => {
  return axios.delete(`/users/${id}/`);
};

const createAutoEscalation = (id, data) => {
  return axios.post(`/escalation/${id}/escalate/`, data);
};

const drawWithAI = (data) => {
  return axios.post(`/fishbone/`, data);
};

const getDiagramTypes = () => {
  return axios.get(`/diagram-types/`);
};

/**
 * Get diagram categories with full metadata for My Tools UI
 * Returns categories with nested diagrams, layouts, icons, etc.
 */
const getDiagramCategories = () => {
  return axios.get(`/diagram-categories/`);
};

/**
 * Get available layouts for a specific diagram type
 * @param {string} diagramId - The diagram ID (e.g., 'fishbone', 'rca')
 */
const getDiagramLayouts = (diagramId) => {
  return axios.get(`/diagrams/${diagramId}/layouts/`);
};

/**
 * Get full diagram info including schema and prompts
 * @param {string} diagramId - The diagram ID
 */
const getDiagramInfo = (diagramId) => {
  return axios.get(`/diagrams/${diagramId}/`);
};

/**
 * Get AI-suggested diagram types based on user prompt
 * @param {string} prompt - User's input prompt
 * @param {string} context - Optional context (e.g., problem statement)
 * @param {number} limit - Max suggestions (default: 3, max: 5)
 */
const getDiagramSuggestions = (prompt, context = "", limit = 3) => {
  return axios.post(`/diagram-suggestions/`, { prompt, context, limit });
};

/**
 * Get user's favorite diagram types
 */
const getDiagramFavorites = () => {
  return axios.get(`/diagram-favorites/`);
};

/**
 * Add a diagram type to favorites
 * @param {string} diagramId - The diagram ID to favorite
 */
const addDiagramFavorite = (diagramId) => {
  return axios.post(`/diagram-favorites/`, { diagram_id: diagramId });
};

/**
 * Remove a diagram type from favorites
 * @param {string} diagramId - The diagram ID to unfavorite
 */
const removeDiagramFavorite = (diagramId) => {
  return axios.delete(`/diagram-favorites/`, {
    data: { diagram_id: diagramId },
  });
};

/**
 * Get user's recently created diagrams
 * @param {number} limit - Max recent diagrams (default: 5, max: 10)
 */
const getRecentDiagrams = (limit = 5) => {
  return axios.get(`/recent-diagrams/`, { params: { limit } });
};

/**
 * Get diagram analytics (most generated types)
 * @param {number} days - Number of days to look back (default: 30)
 * @param {number} limit - Max results to return (default: 10)
 */
const getDiagramAnalytics = (days = 30, limit = 10) => {
  return axios.get(`/diagram-analytics/`, { params: { days, limit } });
};

const createSuperTask = (data) => {
  return axios.post(`/tasks/create-super-task/`, data);
};

const getSuperTaskGroups = () => {
  return axios.get(`/tasks/super-task-groups/`);
};

const getSuperTaskGroupDetails = (
  groupId,
  page = 1,
  perPage = 20,
  search = "",
  status = "",
) => {
  const params = new URLSearchParams({
    groupId,
    page: page.toString(),
    perPage: perPage.toString(),
  });

  if (search) params.append("search", search);
  if (status) params.append("status", status);

  return axios.get(`/tasks/super-task-group-details/?${params.toString()}`);
};

const getUsersEscalations = (userId) => {
  return axios.get(`/escalation/escalated-to-user/?user_id=${userId}`);
};

const getTeamsPerformance = () => {
  return axios.get("/teams/performance/");
};

const getUserReports = () => {
  return axios.get(`/user-reports`);
};

const updateFormData = (id, data) => {
  return axios.patch(`/session/${id}/`, data);
};

const deleteReport = (id) => {
  return axios.delete(`/session/${id}/`);
};

const addTheme = (data) => {
  return axios.post("/strategic-themes/", data);
};

// Edit report showing logic
const editReportTemplateVisiblity = (id, data) => {
  return axios.get(`/session/${id}/feedback/ `, data, {
    // auth is handled by axios interceptor
  });
};

// Get all themes
const getThemes = () => {
  return axios.get("/strategic-themes/");
};

// Update an existing theme
const updateTheme = (id, data) => {
  return axios.patch(`/strategic-themes/${id}/`, data);
};

// Delete a theme
const deleteTheme = (id) => {
  return axios.delete(`/strategic-themes/${id}/`);
};

const getMetricCategories = () => axios.get("/metric-categories/");
const addMetricCategory = (data) => axios.post("/metric-categories/", data);
const updateMetricCategory = (id, data) =>
  axios.put(`/metric-categories/${id}/`, data);
const deleteMetricCategory = (id) => axios.delete(`/metric-categories/${id}/`);

const getMetrics = () => {
  return axios.get("/metric-names/");
};

const addMetric = (metricData) => {
  return axios.post("/metric-names/", metricData);
};

const updateMetric = (id, metricData) => {
  return axios.put(`/metric-names/${id}/`, metricData);
};

const deleteMetric = (id) => {
  return axios.delete(`/metric-names/${id}/`);
};

const getCostBenefitCategories = () => {
  return axios.get("/costbenefit-categories/");
};

const deleteCostBenefitCategories = (categoryId) => {
  return axios.delete(`/costbenefit-categories/${categoryId}`);
};

const deleteCostBenefitSubcategory = (subCategoryId) => {
  return axios.delete(`/costbenefit-subcategories/${subCategoryId}/`);
};

const updateCostBenefitCategory = (id, values) => {
  return axios.put(`/costbenefit-categories/${id}/`, values);
};

const createCostBenefitCategory = (values) => {
  return axios.post("/costbenefit-categories/", values);
};

const updateCostBenefitSubcategory = (id, values) => {
  return axios.put(`/costbenefit-subcategories/${id}/`, values);
};

const createCostBenefitSubcategory = (values) => {
  return axios.post("/costbenefit-subcategories/", values);
};

const uploadCsvForAdmin = (formData) => {
  return axios.post("/users/admincsv/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const createDivision = (data) => {
  return axios.post("/divisions/", data);
};

const deleteDivision = (id) => {
  return axios.delete(`/divisions/${id}/`);
};

const updateDivision = (id, data) => {
  return axios.put(`/divisions/${id}/`, data);
};

const createDepartment = (data) => {
  return axios.post("/departments/", data);
};

const deleteDepartment = (id) => {
  return axios.delete(`/departments/${id}/`);
};

const updateDepartment = (id, data) => {
  return axios.put(`/departments/${id}/`, data);
};

const getProjectCostBenefits = (projectId) => {
  return axios.get(`/costbenefits/?project_id=${projectId}`);
};

const addCostBenefitDataPoint = (data) => {
  return axios.post(`/costbenefit-datapoints/`, data);
};

const updateCostBenefitDataPoint = (id, data) => {
  return axios.patch(`/costbenefit-datapoints/${id}/`, data);
};

const getProjectMetrics = (projectId) => {
  return axios.get(`/metrics/?project_id=${projectId}`);
}; // **************************

const addProjectMetric = (data) => {
  return axios.post(`/metrics/`, data);
};

const deleteProjectMetric = (id) => {
  return axios.delete(`/metrics/${id}/`);
};

const addDataPoint = (data) => {
  return axios.post(`/metric-datapoints/`, data);
}; // ********************

const updateProjectMetric = (metricId, metricData) => {
  return axios.put(`/metrics/${metricId}/`, metricData);
};

const createConsultationForm = async (data) => {
  return axios.post("/consultation-form/", data);
};

const createContactForm = async (data) => {
  return axios.post("/contact-us/", data);
};

const createEarlyAccess = async (data) => {
  return axios.post("/early-access/", data);
};

const getConsultationData = () => {
  return axios.get("/consultation-form/");
};

const getContactData = () => {
  return axios.get("/contact-us/");
};

const getEarlyAccessData = () => {
  return axios.get("/early-access/");
};

const getProjectStaffAnalytics = (month) => {
  return axios.get(`/analytics/project-staff-patient/?month=${month}`);
};

const getEscalationStats = (month) => {
  return axios.get(`/analytics/escalation-dashboard/?month=${month}`);
};

const getEscalationStatusDistribution = (month) => {
  return axios.get(`/analytics/escalation-status-distribution/?month=${month}`);
};

const getEscalationStatusMonthWise = (month) => {
  return axios.get(`/analytics/escalation-created-mitigated/?month=${month}`);
};

const getEscalationEconomicImpact = (month) => {
  return axios.get(`/analytics/escalation-economic-impact/?month=${month}`);
};

const getQuarterlyCostBenefit = (month) => {
  return axios.get(
    `/analytics/projects-quarterly-cost-benefit/?month=${month}`,
  );
};

const getProjectCardAnalytics = (month) => {
  return axios.get(`/analytics/project-card-analytics/?month=${month}`);
};

const getRevenueBreakdown = (month) => {
  return axios.get(`/analytics/projects-benefit-monthly/?month=${month}`);
};

const getAllOrganisations = () => {
  return axios.get(`/organisations/`);
};

const getOrganisationById = (id) => {
  return axios.get(`/organisations/${id}/`);
};

const createOrganisation = (organisationData) => {
  return axios.post(`/organisations/`, organisationData);
};

const updateOrganisation = (id, organisationData) => {
  return axios.put(`/organisations/${id}/`, organisationData);
};

const deleteOrganisation = (id) => {
  return axios.delete(`/organisations/${id}/`);
};

const getProjectCompletion = (month) => {
  return axios.get(`/analytics/projects-completion-count/?month=${month}`);
};

const getCostBenefitByCategoriesData = (month) => {
  return axios.get(`/analytics/cost-benefit-donut/?month=${month}`);
};

const getProjectBreakdown = (month) => {
  return axios.get(
    `/analytics/project-type-breakdown-dashboard/?month=${month}`,
  );
};

const getProjectRadarData = (month) => {
  return axios.get(`/analytics/project-escalation-radar/?month=${month}`);
};

const getSentimentAnalysis = (month) => {
  return axios.get(`/analytics/sentiment-analysis/?month=${month}`);
};

const getSentimentWordCloud = (month) => {
  return axios.get(`/analytics/sentiment-analysis-word-cloud/?month=${month}`);
};

const getOrganisationLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=organisation&month=${month}`);
};

const getDivisionLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=division&month=${month}`);
};

const getTeamLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?type=team&month=${month}`);
};

const getIndividualLeaderboard = (month) => {
  return axios.get(`/analytics/leaderboard/?month=${month}`);
};

const getProjectMonthlyBreakdown = (month) => {
  return axios.get(`/analytics/project-monthly-breakdown/?month=${month}`);
};

const getProjectFunnel = (month) => {
  return axios.get(`/analytics/project-funnel/?month=${month}`);
};

const getEscalationSeverityType = (month) => {
  return axios.get(`/analytics/escalations-severity-type/?month=${month}`);
};

const getEscalationHeatmap = (month) => {
  return axios.get(`/analytics/escalations-heatmap/?month=${month}`);
};

const getPotentialProjectAnalytics = (month) => {
  return axios.get(`/analytics/parked-project-analytics/?month=${month}`);
};

const getMilestonesByStages = (id) => {
  return axios.get(`/milestone/?project_id=${id}&isStage=true`);
};

const getDefaultTemplateData = (id) => {
  return axios.get(`/template-data/`);
};

// List all features
const getAllFeatures = () => {
  return axios.get("/features/");
};

// Create a new feature request
const createFeatureRequest = (featureData) => {
  return axios.post("/features/", featureData);
};

// Upvote a feature
const upvoteFeature = (featureId) => {
  return axios.post("/feature-vote/", { feature: featureId, vote_type: "up" });
};

// Downvote a feature (or change the vote to downvote)
const downvoteFeature = (featureId) => {
  return axios.post("/feature-vote/", {
    feature: featureId,
    vote_type: "down",
  });
};

const createIdeaComment = (data) => {
  return axios.post("/feature-comments/", data);
};

const getSentimentSPCAnalytics = () => {
  return axios.get("/analytics/sentiment-spc/");
};

const getPotentialProjects = () => {
  return axios.get(`/analytics/parked-project-analytics/`);
};

const getRaciData = (id) => {
  return axios.get(`/analytics/raci-matrix/?project_id=${id}`);
};

const getWorkloadData = (id) => {
  return axios.get(`/analytics/workload/?project_id=${id}`);
};

const getMetricData = (id) => {
  return axios.get(`/metrics/?project_id=${id}`);
};

const getMetricById = (id) => {
  return axios.get(`/metrics/${id}/`);
};

const createCompleteProfile = (id, data) => {
  return axios.post(`/complete-profile/?user_id=${id}`, data);
};

const deleteSubTask = (id) => {
  return axios.delete(`/subtask/${id}/`);
};

const sendInvite = (data) => {
  return axios.post("/send-invite/", data);
};

const uploadProjectFile = (data, id) => {
  return axios.post(`/project/${id}/upload-file/`, data);
};

const getOrganisationLimit = () => {
  return axios.get(`/organisation-usage/`);
};

const userCheckoutSession = (data) => {
  return axios.post(`/checkout-session/`, data);
};

// Billing functions
// const getPlanMetadata = () => {
//   return axios.get(`/plan-metadata/`, { headers: AuthHeader() });
// };

// const createCheckoutSession = (data) => {
//   return axios.post(`/checkout-session/`, data, { headers: AuthHeader() });
// };

// Usage functions
// const getOrganisationUsage = (orgId) => {
//   return axios.get(`/organisation-usage/${orgId}/`, { headers: AuthHeader() });
// };

const getIndivialProjectWorkload = (id) => {
  return axios.get(`/project/${id}/workload/`);
};

// /tasks/paginated-tasks/?user_id=10&page=1
const getAllTasksByPagination = (id, page) => {
  return axios.get(`/tasks/paginated-tasks/?user_id=${id}&page=${page}`);
};

const getAllCompletedTasksByPagination = (id, page) => {
  return axios.get(
    `/tasks/paginated-completed-tasks/?user_id=${id}&page=${page}`,
  );
};

const getAllTodaysTasksByPagination = (id, page) => {
  return axios.get(`/tasks/paginated-today-tasks/?user_id=${id}&page=${page}`);
};

const getPaginatedTasksForCalender = (id, date) => {
  return axios.get(`/tasks/paginated-month-tasks/?user_id=${id}&month=${date}`);
};

const getPaginatedTodoTask = (id, page) => {
  return axios.get(`/tasks/paginated-to-do-tasks/?user_id=${id}&page=${page}`);
};

const getPaginatedInProgressTask = (id, page) => {
  return axios.get(
    `/tasks/paginated-in-progress-tasks/?user_id=${id}&page=${page}`,
  );
};

// PROJECT PAGE ROUTES

const getPaginatedInReviewProject = (id, page) => {
  return axios.get(
    `/project/paginated-review-projects/?user_id=${id}&page=${page}`,
  );
};

const getPaginatedPlannedProject = (id, page) => {
  return axios.get(
    `/project/paginated-planned-projects/?user_id=${id}&page=${page}`,
  );
};

const getPaginatedInProgressProject = (id, page) => {
  return axios.get(
    `/project/paginated-inprogress-projects/?user_id=${id}&page=${page}`,
  );
};

const getPaginatedCompletedProject = (id, page) => {
  return axios.get(
    `/project/paginated-completed-projects/?user_id=${id}&page=${page}`,
  );
};

const getPaginatedArchivedProject = (id, page) => {
  return axios.get(
    `/project/paginated-archived-projects/?user_id=${id}&page=${page}`,
  );
};

const getPaginatedParkedProject = (id, page) => {
  return axios.get(
    `/project/paginated-parked-projects/?user_id=${id}&page=${page}`,
  );
};

// Bot Generation Status Check
const getBotGenerationStatus = (sessionId) => {
  return axios.get(`/bot-status?session_id=${sessionId}`);
};

// Data Integrity Sync - Admin functions to fix department/division inconsistencies
const getDataIntegrityStatus = () => {
  return axios.get("/data-integrity-sync/");
};

const runDataIntegritySync = (options = {}) => {
  // options: { sync_users: true, sync_projects: true, force: false, dry_run: false }
  return axios.post("/data-integrity-sync/", options);
};

const getReportingSummary = (reportType, month) => {
  let url = `/analytics/reporting-summary/?report_type=${reportType}`;
  if (month) url += `&month=${month}`;
  return axios.get(url);
};

const getSavedReports = () => {
  return axios.get("/analytics/saved-reports/");
};

const getSavedReport = (id) => {
  return axios.get(`/analytics/saved-reports/${id}/`);
};

const saveReport = (payload) => {
  // payload: { report_data, report_type, title?, filter_month?, insights? }
  return axios.post("/analytics/saved-reports/", payload);
};

const updateSavedReport = (id, payload) => {
  return axios.patch(`/analytics/saved-reports/${id}/`, payload);
};

const deleteSavedReport = (id) => {
  return axios.delete(`/analytics/saved-reports/${id}/`);
};

const generateReportInsights = (reportData) => {
  return axios.post("/analytics/report-insights/", { report_data: reportData });
};

const generatePptxNarrative = (reportData) => {
  return axios.post("/analytics/report-pptx-narrative/", {
    report_data: reportData,
  });
};

const exportReportPDF = (reportData, insights = "") => {
  return axios.post(
    "/analytics/report-pdf-export/",
    { report_data: reportData, insights },
    { responseType: "blob" },
  );
};

const ProjectServices = {
  editReportTemplateVisiblity,
  getAllTasksByPagination,
  getAllCompletedTasksByPagination,
  getAllTodaysTasksByPagination,
  getPaginatedTodoTask,
  getPaginatedInProgressTask,
  getPaginatedTasksForCalender,

  // project Pagination
  getPaginatedInReviewProject,
  getPaginatedPlannedProject,
  getPaginatedInProgressProject,
  getPaginatedCompletedProject,
  getPaginatedArchivedProject,
  getPaginatedParkedProject,

  getOrganisationLimit,
  getAllFeatures,
  uploadProjectFile,
  getUserDepartments,
  getUserDivisions,
  getUserTeams,
  sendInvite,
  createCompleteProfile,
  getDefaultTemplateData,
  getMetricData,
  getMetricById,
  deleteSubTask,
  getWorkloadData,
  getRaciData,
  getPotentialProjects,
  createIdeaComment,
  createFeatureRequest,
  upvoteFeature,
  downvoteFeature,
  getSentimentSPCAnalytics,
  getSentimentAnalysis,
  getMilestonesByStages,
  getSentimentWordCloud,
  getOrganisationLeaderboard,
  getDivisionLeaderboard,
  getTeamLeaderboard,
  getIndividualLeaderboard,
  getProjectMonthlyBreakdown,
  getProjectFunnel,
  getPotentialProjectAnalytics,
  getProjectMetrics,
  getProjectCostBenefits,
  addCostBenefitDataPoint,
  updateCostBenefitDataPoint,
  getProjectRadarData,
  getProjectBreakdown,
  getProjectCompletion,
  getQuarterlyCostBenefit,
  getCostBenefitByCategoriesData,
  getAllOrganisations,
  getOrganisationById,
  createOrganisation,
  updateOrganisation,
  deleteOrganisation,
  getRevenueBreakdown,
  createEarlyAccess,
  getProjectCardAnalytics,
  getEscalationEconomicImpact,
  getEscalationStatusMonthWise,
  getEscalationStatusDistribution,
  getEscalationHeatmap,
  getEscalationSeverityType,
  getProjectStaffAnalytics,
  getConsultationData,
  getEarlyAccessData,
  getContactData,
  createContactForm,
  createConsultationForm,
  addDataPoint,
  deleteProjectMetric,
  updateProjectMetric,
  addTheme,
  getThemes,
  updateTheme,
  deleteTheme,
  getMetrics,
  addProjectMetric,
  addMetric,
  createDivision,
  deleteDivision,
  updateDivision,
  createDepartment,
  deleteDepartment,
  updateDepartment,
  uploadCsvForAdmin,
  updateMetric,
  deleteMetric,
  getCostBenefitCategories,
  deleteCostBenefitCategories,
  updateCostBenefitSubcategory,
  createCostBenefitSubcategory,
  createCostBenefitCategory,
  updateCostBenefitCategory,
  deleteCostBenefitSubcategory,
  getMetricCategories,
  addMetricCategory,
  updateMetricCategory,
  deleteMetricCategory,
  addTemplate,
  updateFormData,
  deleteReport,
  getUserReports,
  getTeamsPerformance,
  createSuperTask,
  getSuperTaskGroups,
  getSuperTaskGroupDetails,
  drawWithAI,
  getDiagramTypes,
  getDiagramCategories,
  getDiagramLayouts,
  getDiagramInfo,
  getDiagramSuggestions,
  getDiagramFavorites,
  addDiagramFavorite,
  removeDiagramFavorite,
  getRecentDiagrams,
  getDiagramAnalytics,
  getUsersEscalations,
  getEscalationComment,
  createEscalationComment,
  getNotificationComments,
  getAdminAnalytics,
  createAutoEscalation,
  updateUser,
  deleteUser,
  getAllUsers,
  getStrategicThemes,
  getStrategicThemesClearPlan,
  getDepartments,
  getDivisions,
  getConversations,
  deleteDrawing,
  getProjects,
  getProjectsDashboard,
  convertProjectIntoTasks,
  updateChatRequest,
  getProjectTasks,
  getUsersTasks,
  updateTaskStatus,
  getProjectsCount,
  addNewTask,
  updateProjectStatus,
  getProjectDetails,
  generateSubTasks,
  getSubTasks,
  updateSubTaskStatus,
  toggleVote,
  hasVoted,
  addComment,
  getProjectComments,
  createNotification,
  getNotifications,
  getUsersNotification,
  getUnreadNotificationPreview,
  markNotificationRead,
  updateNotification,
  readAllNotification,
  deleteAllNotification,
  // Strategic Notification Actions
  approveNotification,
  rejectNotification,
  delegateNotification,
  escalateNotification,
  getAssuranceScorecard,
  getSuggestedEscalationTarget,
  flagNotificationForSupport,
  updateNotificationChecklist,
  updateNotificationEffort,
  getMilestones,
  createMilestone,
  getPriorityProjectsByTheme,
  deleteMilestone,
  addNote,
  deleteNote,
  updateNote,
  getProjectNotes,
  updateMilestone,
  getMilestoneTasks,
  addEscalation,
  getProjectEscalations,
  updateEscalation,
  deleteEscalation,
  searchUser,
  createTeam,
  updateTeam,
  deleteTeam,
  getUserTeam,
  getTemplates,
  getTemplateById,
  getUserDrawings,
  deleteNotification,
  getProjectDrawings,
  getProjectsByDivision,
  getProjectsByTheme,
  delegateToSeniors,
  getAllProjects,
  getApprovalProjects,
  updateProfile,
  createChatRequest,
  getCurrentMessages,
  getEscalationStats,
  userCheckoutSession,
  addTasksSubtasks,
  getIndivialProjectWorkload,
  // Billing
  getPlanMetadata,
  createCheckoutSession,
  estimateProration,
  updateSeats,
  // Usage
  getOrganisationUsage,
  // Bot Status
  getBotGenerationStatus,

  // Data Integrity Sync (Admin)
  getDataIntegrityStatus,
  runDataIntegritySync,

  // Meeting Notes (AI project update)
  uploadMeetingNotes,
  proposeMeetingNotes,
  getMeetingNotesJob,
  applyMeetingNotes,
  generateMeetingNotesProposal,
  applyMeetingNotesChanges,

  // Reporting Tool
  getReportingSummary,
  getSavedReports,
  getSavedReport,
  saveReport,
  updateSavedReport,
  deleteSavedReport,
  generateReportInsights,
  generatePptxNarrative,
  exportReportPDF,

  // Benefit Realization Tracking
  classifyBenefits,
  getMilestoneBenefitLinks,
  createMilestoneBenefitLink,
  bulkCreateMilestoneBenefitLinks,
  updateMilestoneBenefitLink,
  deleteMilestoneBenefitLink,
  confirmMilestoneBenefits,
  getPendingBenefitConfirmations,
  getBenefitRealizationSummary,
  getRecurringBenefitReminders,
  confirmRecurringBenefit,
  generateBenefitLinks,
};

export default ProjectServices;
